import React from "react";

import MuiContainer from "@material-ui/core/Container";
import { NotificationContainer } from "../../containers/NotificationContainer/NotificationContainer";
import { makeStyles } from "@material-ui/styles";
import { styled } from 'styled-components'

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.mixins.toolbar.minHeight,
        marginLeft: theme.spacing(7) + 1,
        padding: theme.spacing(3),
        height: "calc(100vh - 64px)",
    },
    container: {
        height: "100%",
    },
    chartContainer: {
        paddingRight: "10px",
        minWidth: "100%",
        maxWidth: '1600px',
    },
}));

const MuiContainerMedia = styled(MuiContainer)`
    padding-right: "10px";
    /* min-width: "100%";
    max-width: '1600px'; */

    /* @media(min-width: 1280px) {
        max-width: 1920px !important;
    } */

    /* @media(min-width: 1920px) {
        width: 1600px !important;
    } */

`

export const ContainerDataLens = ({ children, ...otherProps }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <MuiContainerMedia
                minWidth="1600px"
                className={
                    otherProps.chart ? classes.chartContainer : classes.container
                }
                component={"main"}
                {...otherProps}
            >
                {children}
            </MuiContainerMedia>
            <NotificationContainer />
        </div>
    );
};